import { Typography } from 'antd';
import styled from 'styled-components';
import { TextProps } from 'antd/es/typography/Text';

const Text = styled(Typography.Text)`
  color: ${p => p.theme.text};
`;

// Regular
export const TextRegular12 = styled(Text)<TextProps>`
  font-size: 12px;
  line-height: 20px;
`;
export const TextRegular14 = styled(Text)<TextProps>`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;
export const TextRegular16 = styled(Text)<TextProps>`
  font-size: 16px;
  line-height: 22px;
`;
export const TextRegular24 = styled(Text)<TextProps>`
  font-size: 24px;
  line-height: 32px;
`;
export const TextRegular56 = styled(Text)<TextProps>`
  font-size: 56px;
  line-height: 64px;
`;

// Semibold
export const TextSemibold16 = styled(TextRegular16)<TextProps>`
  font-weight: 600;
`;

export const TextSemibold24 = styled(TextRegular24)<TextProps>`
  font-weight: 600;
`;

export const TextSemibold14 = styled(TextRegular14)<TextProps>`
  font-weight: 600;
`;

export const TextSemibold12 = styled(TextRegular12)<TextProps>`
  font-weight: 600;
`;

export const TextSemibold20 = styled(Text)<TextProps>`
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
`;
